import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import AuthForm from '@/components/authForm/AuthForm';
import { CustomPlaceholders } from '@/components/authForm/AuthForm/types';
import Header from '@/components/header/Header';
import Loader from '@/components/Loader';
import GridWrapper from '@/components/ui/GridWrapper';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAppLoadedState } from '@/hooks/store';
import genericMessages from '@/messages/messages';
import getParamAsString from '@/utils/getParamsAsString';
import redirect, { protectOpenRedirect } from '@/utils/legacy/redirect';

import { Heading, Wrapper } from './styles';

const AuthPageWrapper = () => {
	const searchParams = useSearchParams();
	const { authPrompt } = useAuthPrompt();
	const appLoaded = useAppLoadedState();
	const { formatMessage } = useIntl();
	const [isCollege, setIsCollege] = useState(false);

	const onAuthSuccess = () => {
		if (isCollege) {
			redirect(`/college/verify?collegeName=${searchParams?.get('college_name') ?? ''}`);
		} else if (searchParams?.has('continue')) {
			const continueUri = getParamAsString(searchParams.get('continue'));
			const sanitizedContinueUri = protectOpenRedirect(continueUri);
			redirect(sanitizedContinueUri);
		} else {
			redirect('/app/profile/manage-subscription');
		}
	};

	const getCustomPlaceholders = (): CustomPlaceholders => {
		if (isCollege) {
			return isCollege ? { email: `Your ${searchParams?.get('college_name')} Email` } : null;
		}

		return null;
	};

	useEffect(() => {
		if (searchParams?.get('source') === 'college-page') {
			// TODO: refactor this code to follow best practices
			// eslint-disable-next-line react-hooks/set-state-in-effect
			setIsCollege(true);
		}
	}, [searchParams]);

	return (
		<>
			<Header isStatic hideMenu hideProfile />
			<GridWrapper columns={4} id={MAIN_CONTENT_ID}>
				<Wrapper>
					{!appLoaded ? (
						<Loader color="gray5" />
					) : (
						<>
							<Heading>
								{formatMessage(
									authPrompt === 'signup' ? genericMessages.signupTitle : genericMessages.loginTitle,
								)}
							</Heading>
							<AuthForm
								onAuthSuccess={onAuthSuccess}
								isCollege={isCollege}
								customPlaceholders={getCustomPlaceholders()}
							/>
						</>
					)}
				</Wrapper>
			</GridWrapper>
		</>
	);
};

export default AuthPageWrapper;
